import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useFoodPackageAddMutation,
  useFoodPackageEditMutation,
  useLazyFoodPackageDeleteQuery,
  useLazyFoodPackageShowQuery,
} from "../../redux/api/api";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { saveLoader } from "../../redux/slice/loaderNoti";

const FoodPackage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.itemType;

  // RTK QUERY
  const [foodAddApi] = useFoodPackageAddMutation();
  const [foodEditApi] = useFoodPackageEditMutation();
  const [foodViewApi] = useLazyFoodPackageShowQuery();
  const [foodDeleteApi] = useLazyFoodPackageDeleteQuery();

  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [price_per_person, setprice_per_person] = useState("");
  const [price_per_personErr, setprice_per_personErr] = useState(false);
  const [btn, setBtn] = useState(false);
  const [menuItems, setMenuItems] = useState([
    {
      menu: "",
      menu_item: "",
    },
  ]);
  const [menuErr, setMenuErr] = useState(false);
  const [menu_itemErr, setMenu_itemErr] = useState(false);

  const submitHandler = () => {
    let checkmenu;
    let checkmenu_item;

    menuItems?.map((item, ind) => {
      checkmenu = Object.values(item).every((x) => x === " " || x === "");
      checkmenu_item = Object.values(item).every((x) => x === " " || x === "");
    });

    if (
      name?.length == 0 ||
      checkmenu == true ||
      checkmenu_item == true ||
      price_per_person?.length == 0
    ) {
      setprice_per_personErr(true);
      setNameErr(true);
      setMenu_itemErr(true);
      setMenuErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("price_per_person", price_per_person);
      formdata.append("name", name);

      let count = 1;

      for (var x = 0; x < menuItems.length; x++) {
        if (menuItems[x].menu && menuItems[x].menu_item) {
          formdata.append("food_menus[" + x + "][menu]", menuItems[x].menu);
          formdata.append(
            "food_menus[" + x + "][menu_item]",
            menuItems[x].menu_item
          );

          formdata.append(
            "food_menus[" + x + "][id]",
            menuItems[x].id ? menuItems[x].id : ""
          );
        } else {
          count = count + 1;
        }
      }

      if (count == 1) {
        if (types == "edit") {
          dispatch(saveLoader(true));
          setBtn(true);
          foodEditApi({ id: location?.state?.item?.id, payload: formdata })
            .unwrap()
            .then((res) => {
              dispatch(saveLoader(false));
              setBtn(false);
              if (res?.status == "success") {
                Swal.fire({
                  text: res?.message,
                  icon: "success",
                });
                navigate(-1);
              }
            })
            .catch((err) => {
              dispatch(saveLoader(false));
              setBtn(false);
              console.log("err", err);
            });
        } else {
          dispatch(saveLoader(true));
          setBtn(true);
          foodAddApi({ id: location?.state?.data?.id, payload: formdata })
            .unwrap()
            .then((res) => {
              dispatch(saveLoader(false));
              setBtn(false);
              if (res?.status === "success") {
                Swal.fire({
                  text: res?.message,
                  icon: "success",
                });
                navigate(-1);
              }
            })
            .catch((err) => {
              dispatch(saveLoader(false));
              setBtn(false);
              console.error("Error", err);
            });
        }
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    foodViewApi(location?.state?.item?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          let data = res?.food_package;
          setName(data?.package_name);
          setprice_per_person(data?.price_per_person);

          if (data?.menuitems?.length > 0) {
            setMenuItems(data?.menuitems);
          }
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.item?.id) {
      getView();
    }
  }, []);

  const deleteFood = (id) => {
    dispatch(saveLoader(true));
    foodDeleteApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          getView();
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  const handleChange = (event, ind, type) => {
    let temp = [...menuItems];

    temp[ind] = {
      ...temp[ind],
      [type]: event,
    };

    setMenuItems(temp);
  };

  const addMenuItem = () => {
    let temp = [...menuItems];
    temp.push({
      menu: "",
      menu_item: "",
    });
    setMenuItems(temp);
  };

  const removeMenuItem = (ind, id) => {
    let temp = [...menuItems];

    if (id) {
      deleteFood(id);
    } else {
      temp.splice(ind);
    }
    setMenuItems(temp);
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-food" : "add-food"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Price Per Person
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setprice_per_person(e.target.value)}
                  value={price_per_person}
                />
              </div>
              {price_per_person?.length == 0 && price_per_personErr && (
                <p className="err">Enter Price Per Person</p>
              )}
            </div>
          </Row>
          <div className="col-md-12 text-start mt-4 mb-4">
            <button
              className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
              onClick={() => addMenuItem()}
              disabled={btn}
            >
              <AddIcon className="f2" />
            </button>
          </div>
          {menuItems?.map((item, ind) => {
            return (
              <Row key={ind}>
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Menu
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      onChange={(e) =>
                        handleChange(e.target.value, ind, "menu")
                      }
                      value={item?.menu}
                    />
                  </div>
                  {item?.menu?.length == 0 && menuErr && (
                    <p className="err">Enter Menu</p>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Item
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      onChange={(e) =>
                        handleChange(e.target.value, ind, "menu_item")
                      }
                      value={item?.menu_item}
                    />
                  </div>
                  {item?.menu_item?.length == 0 && menu_itemErr && (
                    <p className="err">Enter Item</p>
                  )}
                </div>
                {menuItems?.length > 1 && (
                  <div className="col-md-2 mb-3 mt-4">
                    <button
                      className={`submit-btn f2 mt-2 ${
                        btn ? "opacity-50" : ""
                      }`}
                      onClick={() => removeMenuItem(ind, item?.id)}
                      disabled={btn}
                    >
                      <CloseIcon className="f2" />
                    </button>
                  </div>
                )}
              </Row>
            );
          })}

          <Row>
            <div className="col-md-12 text-start mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default FoodPackage;
